import { Theme } from "@mui/material/styles";
import { getColors } from "../../../../utils";

export const AccountBar = (theme: Theme) => ({
  headerStyle: {
    height: 80,
    gap: "40px",
    display: "flex",
    padding: "16px 40px!important",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: getColors().border,
    background: getColors().bgwhite,
  },
  textBlock: {
    display: "flex",
    marginLeft: "16px",
    marginRight: "8px",
  },

  title: {
    lineHeight: 0.8,
    fontWeight: 900,
    textTransform: "uppercase",
  },
  dropdownWrapper: {
    display: "flex",
    flexDirection: "column" as const,
    justifyContent: "center",
    color: theme.palette.text.primary,
  },
});
export const detailsStyle = {
  leftStyle: {
    display: "flex",
    height: "48px",
    alignItems: "center",
    flexShrink: 0,
    minWidth: 0,
  },

  centerStyle: {
    display: "flex",
    height: "48px",
    justifyContent: "center",
    alignItems: "center",
    gap: "16px",
    flexShrink: 1,
  },

  rightStyle: {
    display: "flex",
    width: "340px",
    maxWidth: "max-content",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "16px",
    flexShrink: 1,
    minWidth: 0,
  },
};
